import { newController } from 'alp-node/src';
import deviceService from '../../deviceService';

export default newController({
  async index(ctx) {
    switch (ctx.method) {
      case 'GET': {
        ctx.body = await deviceService.getScreenInfo();
        break;
      }
      case 'POST': {
        const body = await ctx.parseBodyJson();
        if (!['on', 'off'].includes(body.state)) {
          ctx.status = 400;
        } else {
          ctx.body = await deviceService[body.state === 'off' ? 'setScreenOff' : 'setScreenOn']();
        }
        break;
      }
      default:
        ctx.status = 404;
        break;
    }
  },
});
